import React, { ReactNode } from 'react';
import { Wrapper } from './styled';

interface Props {
  ButtonPrev?: ReactNode;
  ButtonNext?: ReactNode;
}

export const ButtonsAction: React.FC<Props> = ({
  ButtonPrev,
  ButtonNext
}) => (
  <Wrapper>
    {ButtonPrev}
    {ButtonNext}
  </Wrapper>
);
